// extracted by mini-css-extract-plugin
export default {"root":"VideoAdsEventbriteLogo-module__root___3lDrl","logo":"VideoAdsEventbriteLogo-module__logo___2qGFj"};